{
  "debugLogin": {
    "number": "Dev-користувач №",
    "signIn": "Dev-вхід",
    "signingIn": "Вхід…",
    "failed": "Не вдалося увійти (HTTP {{status}}). Перевірте, що API використовує ENV=dev.",
    "networkError": "Немає зв’язку з локальним API."
  },
  "common": {
    "retry": "Спробувати ще раз",
    "loadFailed": "Не вдалося завантажити. Спробуйте ще раз.",
    "loading": "Завантаження…",
    "close": "Закрити",
    "dismiss": "Сховати",
    "you": "ви",
    "youCap": "Ви",
    "cancel": "Скасувати",
    "showPassword": "Показати пароль",
    "hidePassword": "Приховати пароль"
  },
  "nav": {
    "main": "Головне меню",
    "skip": "Перейти до вмісту",
    "games": "Ігри",
    "packages": "Паки",
    "profile": "Профіль і налаштування",
    "signIn": "Увійти",
    "admin": "Адмінка",
    "leaderboard": "Рейтинг"
  },
  "notFound": {
    "title": "Такої сторінки немає"
  },
  "roles": {
    "showman": "Ведучий",
    "player": "Гравець",
    "spectator": "Глядач"
  },
  "login": {
    "title": "Оберіть ім'я та грайте",
    "subtitle": "Акаунт не потрібен. Інші гравці бачитимуть ваше ім'я.",
    "nameLabel": "Ваше ім'я",
    "namePlaceholder": "наприклад, Міра",
    "nameHelp": "1–50 символів. Змінити можна пізніше в налаштуваннях.",
    "nameRequired": "Спочатку введіть ім'я.",
    "continueGuest": "Продовжити як гість",
    "signingIn": "Входимо…",
    "discordHelp": "Є Discord? Увійдіть, щоб ваші паки й ім'я були на всіх пристроях.",
    "discord": "Увійти через Discord",
    "discordFailed": "Вхід через Discord не завершився. Спробуйте ще раз або продовжте як гість."
  },
  "home": {
    "inProgress": "Гра триває",
    "stillIn": "Ви досі в грі «{{title}}»",
    "stillInLobby": "Лобі чекає. Ваше місце збережено.",
    "stillInPlaying": "Гра йде. Ваше місце й рахунок збережено.",
    "rejoin": "Повернутися",
    "joinTitle": "Приєднуйтеся до гри за секунди",
    "joinSubtitle": "Вставте посилання-запрошення або код кімнати. Ви потрапите в лобі, де на вас чекає місце.",
    "codeLabel": "Код кімнати або посилання",
    "codeInvalid": "Це не схоже на код кімнати чи посилання на гру.",
    "join": "Приєднатися",
    "watch": "Дивитися",
    "hostTitle": "Проведіть свою гру",
    "hostSubtitle": "Оберіть пак, налаштуйте кімнату, поділіться посиланням. Ви — ведучий.",
    "createGame": "Створити гру",
    "openGames": "Відкриті ігри",
    "search": "Пошук ігор",
    "clearSearch": "Очистити пошук",
    "noMatches": "Немає ігор за вашим пошуком і фільтрами.",
    "filter": "Фільтр ігор",
    "filters": {
      "all": "Усі",
      "lobby": "У лобі",
      "playing": "В процесі"
    },
    "status": {
      "lobby": "У лобі",
      "playing": "В процесі"
    },
    "private": "Пароль",
    "package": "Пак · {{title}}",
    "players": "гравців",
    "host": "Ведучий {{name}}",
    "noGames": "Зараз немає відкритих ігор. Створіть свою та поділіться посиланням!",
    "loadFailed": "Не вдалося завантажити ігри. Перевірте з'єднання та спробуйте ще раз.",
    "hideRejoin": "Сховати",
    "notice": {
      "kicked": "Вас видалили з гри.",
      "deleted": "Ведучий видалив гру.",
      "closed": "Модератор закрив гру."
    }
  },
  "packages": {
    "title": "Паки",
    "search": "Пошук за назвою",
    "language": "Мова",
    "anyLanguage": "Будь-яка",
    "sort": "Сортування",
    "sortNewest": "Найновіші",
    "sortTitle": "Назва А–Я",
    "by": "автор {{name}}",
    "counts": "Раундів: {{rounds}} · питань: {{questions}}",
    "empty": "Нічого не знайдено. Спробуйте інший пошук.",
    "loadFailed": "Не вдалося завантажити паки.",
    "details": "Про пак",
    "pickOne": "Оберіть пак, щоб побачити раунди та провести з ним гру.",
    "rounds": "Раунди",
    "roundCounts": "тем: {{themes}} · питань: {{questions}}",
    "finalThemes": "Фінальних тем: {{count}}",
    "has": "Є {{list}}",
    "special": "Питання: {{list}}",
    "media": {
      "images": "зображення",
      "audio": "аудіо",
      "video": "відео"
    },
    "host": "Провести гру з цим паком",
    "signInToHost": "Увійдіть, щоб провести гру",
    "prev": "Назад",
    "next": "Далі",
    "page": "Сторінка {{page}} з {{pages}}",
    "upload": "Завантажити пакет",
    "create": "Створити пакет",
    "sortOldest": "Найстаріші",
    "sortTitleDesc": "Назва Я–А",
    "sortAuthor": "Автор",
    "moreFilters": "Більше фільтрів",
    "hideFilters": "Менше фільтрів",
    "age": "Вікове обмеження",
    "anyAge": "Будь-яке",
    "ageNone": "Для всіх",
    "roundsRange": "Раунди",
    "questionsRange": "Питання",
    "min": "Від",
    "max": "До",
    "onlyMine": "Лише мої пакети",
    "clearFilters": "Скинути фільтри",
    "preview": "Переглянути питання",
    "uploadUnfinished": "Завантаження не завершено",
    "uploadUnfinishedHelp": "Автор ще завантажує частину медіа цього пакета, тож почати з ним гру поки не можна.",
    "uploadUnfinishedAuthor": "Частину медіафайлів не завантажено, тому ніхто поки не може почати гру з цим пакетом. Завершіть завантаження, щоб у нього можна було грати.",
    "resumeUpload": "Завершити завантаження"
  },
  "questionTypes": {
    "simple": "Звичайне",
    "stake": "Ставка",
    "secret": "Кіт у мішку",
    "noRisk": "Без ризику",
    "hidden": "Приховане",
    "choice": "З варіантами"
  },
  "create": {
    "back": "До паків",
    "title": "Створення гри",
    "name": "Назва гри",
    "defaultTitle": "Гра {{name}}",
    "players": "Гравці",
    "upTo": "До {{count}}",
    "age": "Вікове обмеження",
    "ageNone": "Для всіх",
    "whoCanJoin": "Хто може приєднатися",
    "public": "Усі, хто має посилання",
    "private": "За паролем",
    "password": "Пароль",
    "passwordPlaceholder": "Залиште порожнім — згенеруємо",
    "passwordHelp": "Літери, цифри, - та _. Гравці вводять його один раз під час входу.",
    "passwordInvalid": "До 16 літер, цифр, - або _.",
    "titleTooShort": "Назва гри має містити щонайменше 3 символи.",
    "submit": "Створити й відкрити лобі",
    "creating": "Створюємо…",
    "youAreShowman": "Ви будете ведучим. Гравці приєднаються за посиланням або кодом кімнати.",
    "package": "Пак",
    "changePackage": "Змінити пак",
    "noPackage": "Спочатку оберіть пак.",
    "pickPackage": "До каталогу паків",
    "rules": {
      "title": "Правила",
      "falseStart": "Фальстарти",
      "falseStartHelp": "Кнопка відкривається після того, як питання показано. Хто натисне раніше, блокується на 3 секунди. Вимкніть, щоб натискати можна було будь-коли.",
      "pressMode": "Хто відповідає, якщо натиснули кілька гравців",
      "modes": {
        "random_within_window": "Чесний жереб",
        "first_wins": "Найшвидший"
      },
      "modeHelp": {
        "random_within_window": "Усі, хто натиснув протягом 0,3 с після першого, мають рівні шанси, тож швидкий інтернет не вирішує.",
        "first_wins": "Відповідає той, чиє натискання першим дійшло до сервера."
      },
      "penalty": "За неправильну відповідь знімаються бали",
      "penaltyHelp": "Неправильна відповідь після натискання кнопки віднімає вартість питання. Вимкніть для м’якшої гри. Ставки при неправильній відповіді втрачаються завжди.",
      "roundLimit": "Час на раунд",
      "roundLimitHelp": "Коли час вийде, раунд закінчиться після поточного питання, навіть якщо питання залишилися.",
      "noLimit": "Без обмеження",
      "minutes": "{{count}} хв",
      "seconds": "{{count}} сек.",
      "timers": "Таймери",
      "timer": {
        "answerMs": "Час, щоб натиснути кнопку",
        "answerSubmitMs": "Час на відповідь після натискання",
        "stakeMs": "Час на кожну ставку",
        "secretTransferMs": "Час, щоб передати секретне питання",
        "allPlayAnswerMs": "Час на відповідь, коли відповідають усі",
        "finalAnswerMs": "Час на відповідь у фіналі"
      },
      "startMode": "Початок гри",
      "startAutomatic": "Коли всі готові",
      "startManual": "Коли вирішить ведучий"
    }
  },
  "settings": {
    "title": "Налаштування",
    "guestAccount": "Гостьовий акаунт",
    "displayName": "Відображуване ім'я",
    "nameRequired": "Ім'я не може бути порожнім.",
    "save": "Зберегти",
    "saved": "Збережено ✓",
    "look": "Вигляд",
    "theme": "Тема",
    "themes": {
      "midnight": "Midnight",
      "daylight": "Денне світло",
      "broadcast": "Broadcast",
      "boldPop": "Bold Pop",
      "softParty": "Soft Party"
    },
    "comingLater": "Згодом",
    "language": "Мова",
    "feel": "Звук і анімація",
    "sound": "Звукові ефекти",
    "reduceMotion": "Менше анімації",
    "volume": "Гучність медіа",
    "signOut": "Вийти",
    "guestSignOutHelp": "До гостьового акаунта не можна повернутися: наступного разу буде новий гість.",
    "changeAvatar": "Змінити фото",
    "avatarSaving": "Зберігаємо фото…",
    "avatarSaved": "Фото оновлено",
    "avatarErrors": {
      "notImage": "Цей файл не схожий на зображення, яке ми можемо прочитати.",
      "tooBig": "Зображення більше за 20 МБ. Виберіть менше.",
      "generic": "Не вдалося зберегти фото. Спробуйте ще раз."
    },
    "signOutFailed": "Не вдалося вийти. Перевірте з’єднання і спробуйте ще раз."
  },
  "join": {
    "notFound": "Гру не знайдено",
    "notFoundHelp": "Немає відкритої гри з кодом {{code}}. Можливо, вона завершилася або в коді помилка.",
    "finished": "Завершена",
    "finishedHelp": "Ця гра вже завершилася.",
    "signedInAs": "Ви приєднаєтеся як {{name}}.",
    "yourName": "Ваше ім'я",
    "guestHelp": "Ми створимо гостьовий акаунт з цим ім'ям.",
    "otherSignIn": "Інші способи входу",
    "password": "Пароль гри",
    "passwordRequired": "Для цієї гри потрібен пароль.",
    "asPlayer": "Грати",
    "watch": "Дивитися",
    "lobbyHelp": "Гравці тиснуть кнопку й заробляють бали. Глядачі бачать усе, але не відповідають.",
    "playingHelp": "Гра вже йде. Займіть вільне місце й грайте з наступного питання або дивіться.",
    "fullHelp": "Усі місця зайняті. Можна дивитися й сісти, коли місце звільниться.",
    "passwordInvalid": "Використайте 1–16 латинських літер, цифри, - або _."
  },
  "game": {
    "joining": "Приєднуємося до гри…",
    "joinFailed": "Не вдалося приєднатися до гри",
    "authFailed": "Сесія завершилася. Увійдіть знову.",
    "tryAgain": "Спробувати ще раз",
    "backHome": "До ігор",
    "over": "Гру завершено",
    "finalRound": "Фінал",
    "watching_one": "{{count}} дивиться",
    "watching_few": "{{count}} дивляться",
    "watching_many": "{{count}} дивляться",
    "watching_other": "{{count}} дивляться",
    "pause": "Пауза",
    "resume": "Продовжити",
    "scores": "Рахунок",
    "noPlayers": "Гравців немає. Ви можете обирати питання самі.",
    "roundLabel": "Раунд {{n}} · {{name}}",
    "rounds": {
      "title": "Раунди пакета",
      "position": "{{current}} із {{total}}",
      "open": "Раунди. {{position}}. Зараз: {{name}}",
      "done": "Пройдено",
      "current": "Зараз",
      "next": "Далі"
    },
    "you": "Ви:",
    "youAre": "Ваша роль: {{role}}",
    "delete": "Видалити гру",
    "deleteConfirm": "Видалити цю гру для всіх?",
    "deleteYes": "Так, видалити",
    "deleteNo": "Скасувати",
    "roundEndsIn": "Раунд закінчиться через {{time}}",
    "roundTimeUp": "Останнє питання раунду",
    "takenOver": "Відкрито в іншому місці",
    "takenOverHelp": "Ваш акаунт приєднався до цієї гри в іншій вкладці чи на іншому пристрої, тож тут гру зупинено. Ваше місце й бали збережено.",
    "takeOver": "Грати тут",
    "leaving": "Виходимо…",
    "leaveFailed": "Не вдалося вийти з гри. Спробуйте ще раз."
  },
  "lobby": {
    "leave": "Вийти з лобі",
    "youAre": "Ви —",
    "kicker": "Лобі · чекаємо гравців",
    "players": "Гравці",
    "readyCount": "Готові {{count}} з {{total}}",
    "openSlot": "Вільне місце",
    "waitingForPlayer": "Чекаємо гравця",
    "clickToSit": "Натисніть, щоб сісти",
    "takeSlot": "Зайняти місце {{n}}",
    "ready": "Готовий",
    "notReady": "Ще не готовий",
    "offline": "Офлайн — місце збережено",
    "spectators": "Глядачі",
    "watching_one": "{{count}} дивиться",
    "watching_few": "{{count}} дивляться",
    "watching_many": "{{count}} дивляться",
    "watching_other": "{{count}} дивляться",
    "spectatorsHelp": "Глядачі бачать усе, але не можуть тиснути кнопку чи робити ставки.",
    "youreSeated": "Ви на місці {{n}} як гравець",
    "imReady": "Я готовий",
    "readyUndo": "✓ Готовий — натисніть, щоб скасувати",
    "readyHelp": "Гра почнеться, коли всі підключені гравці будуть готові. Ведучий також може почати раніше.",
    "waitingForHost": "Чекаємо, поки {{name}} почне · готові {{ready}} з {{total}}.",
    "watchInstead": "Краще дивитися",
    "youreWatching": "Ви дивитеся",
    "spectatorHelp": "Займіть вільне місце, щоб грати. Повернутися можна будь-коли до початку гри.",
    "noSeats": "Усі місця зайняті. До старту місце може звільнитися.",
    "takeSeat": "Зайняти місце",
    "startTitle": "Почати гру",
    "checkPackage": "Пак завантажено",
    "checkPlayers_one": "У кімнаті {{count}} гравець",
    "checkPlayers_few": "У кімнаті {{count}} гравці",
    "checkPlayers_many": "У кімнаті {{count}} гравців",
    "checkPlayers_other": "У кімнаті {{count}} гравця",
    "checkNoPlayers": "Гравців ще немає — поділіться запрошенням",
    "checkAllReady": "Усі готові",
    "checkNotReady_one": "Ще не готовий {{count}} гравець",
    "checkNotReady_few": "Ще не готові {{count}} гравці",
    "checkNotReady_many": "Ще не готові {{count}} гравців",
    "checkNotReady_other": "Ще не готові {{count}} гравця",
    "start": "Почати гру",
    "startHelp": "Почати можна будь-коли. Коли всі готові, гра стартує сама.",
    "startAloneHelp": "Можна почати самому, щоб перевірити пак, але тиснути кнопку не буде кому.",
    "invite": "Запрошення",
    "inviteLink": "Посилання-запрошення",
    "copy": "Копіювати",
    "copied": "Скопійовано",
    "roomCode": "Код кімнати",
    "password": "Пароль",
    "kick": "Видалити {{name}} з гри",
    "moveToSpectators": "Перевести {{name}} до глядачів",
    "moreSeats_one": "Ще {{count}} вільне місце",
    "moreSeats_few": "Ще {{count}} вільні місця",
    "moreSeats_many": "Ще {{count}} вільних місць",
    "moreSeats_other": "Ще {{count}} вільного місця",
    "readyManualHelp": "Позначте готовність. Ведучий вирішує, коли почати гру.",
    "waitingForReady": "{{ready}} / {{total}} гравців готові. Очікуємо на готовність усіх.",
    "startManualHelp": "Готовність — це сигнал для вас. Гра почнеться лише після натискання «Почати».",
    "automaticMode": "Автоматичний старт · коли всі підключені гравці готові.",
    "manualMode": "Старт за рішенням ведучого · готові гравці чекають на ведучого.",
    "showmanOpen": "Місце ведучого вільне",
    "showmanHelp": "Веде гру та оцінює відповіді",
    "becomeShowman": "Стати ведучим",
    "packageOverview": "Раунди й теми",
    "packageUnavailable": "Не вдалося завантажити огляд пакета.",
    "finalRound": "Фінальний раунд"
  },
  "banner": {
    "reconnecting": "З'єднання втрачено — перепідключаємося…",
    "reconnectingHelp": "Ваше місце й рахунок збережено. Щойно повернетеся, екран наздожене гру."
  },
  "pause": {
    "title": "Гра на паузі",
    "waiting": "Чекаємо, поки ведучий продовжить гру."
  },
  "chat": {
    "title": "Чат",
    "empty": "Повідомлень ще немає. Привітайтеся!",
    "message": "Повідомлення",
    "placeholder": "Повідомлення — пробіл не натискає кнопку, поки ви пишете",
    "muted": "Ведучий заборонив вам писати",
    "send": "Надіслати",
    "someone": "Хтось",
    "unread_one": "{{count}} непрочитане повідомлення",
    "unread_few": "{{count}} непрочитані повідомлення",
    "unread_many": "{{count}} непрочитаних повідомлень",
    "unread_other": "{{count}} непрочитаного повідомлення",
    "log": {
      "start": "почав гру",
      "pause": "поставив гру на паузу",
      "unpause": "продовжив гру",
      "reveal": "показав відповідь",
      "buzzerOpen": "відкрив кнопку раніше",
      "nextRound": "перейшов до наступного раунду",
      "nextRoundNamed": "перейшов до наступного раунду: {{round}}",
      "pick": "обрав {{theme}} за {{price}}",
      "toggleRemoved": "прибрав з поля {{theme}} за {{price}}",
      "toggleRestored": "повернув на поле {{theme}} за {{price}}",
      "answerRight": "зарахував відповідь {{player}} ({{points}})",
      "answerWrong": "не зарахував відповідь {{player}} ({{points}})",
      "answerSkipped": "пропустив відповідь {{player}} ({{points}})",
      "undo": "скасував рішення щодо {{player}} ({{points}})",
      "joinMode": "змінив, хто може приєднатися: {{mode}}",
      "kick": "прибрав {{player}} з гри",
      "restrictBanned": "заблокував {{player}}",
      "restrictRestricted": "дозволив {{player}} лише дивитися",
      "restrictMuted": "вимкнув чат для {{player}}",
      "restrictCleared": "зняв обмеження з {{player}}",
      "role": "зробив {{player}}: {{role}}",
      "score": "змінив рахунок {{player}} на {{score}}",
      "slot": "пересадив {{player}} на місце {{slot}}",
      "turn": "передав вибір {{player}}",
      "turnNone": "забрав вибір собі",
      "secret": "віддав питання {{player}}",
      "reviewRight": "зарахував відповідь {{player}}",
      "reviewWrong": "не зарахував відповідь {{player}}",
      "theme": "прибрав тему {{theme}}",
      "rules": "змінив правила: {{changes}}",
      "ruleOn": "увімкнено",
      "ruleOff": "вимкнено"
    },
    "system": "Система"
  },
  "menu": {
    "title": "Меню гри",
    "shortcuts": "Гарячі клавіші",
    "keys": {
      "buzz": "Натиснути кнопку",
      "option": "Обрати варіант відповіді",
      "judge": "Правильно / неправильно (ведучий)",
      "chat": "Відкрити чат",
      "menu": "Це меню"
    },
    "feel": "Звук і анімація",
    "host": "Інструменти ведучого",
    "hostHelp": "У «Керувати гравцями» можна виправити рахунок, передати хід або видалити гравця. Видалення гри поверне всіх на головну.",
    "skipQuestion": "Пропустити питання",
    "nextRound": "До наступного раунду",
    "spectate": "Стати глядачем",
    "leave": "Вийти з гри",
    "skipReveal": "Пропустити показ відповіді",
    "managePlayers": "Керувати гравцями",
    "hostShort": "Ведучий",
    "undoRuling": "Скасувати останню оцінку",
    "boardEdit": "Прибрати питання",
    "boardEditDone": "Готово",
    "joinMode": "Хто може увійти",
    "joinModes": {
      "open": "Усі",
      "spectators_only": "Лише глядачі",
      "closed": "Ніхто новий"
    },
    "rules": {
      "title": "Правила гри",
      "help": "Зміни діють з наступного таймера чи питання; таймер, що вже йде, не зміниться. Усі побачать зміну в чаті.",
      "save": "Зберегти",
      "saving": "Зберігаємо…",
      "reset": "Скасувати зміни"
    },
    "info": {
      "title": "Про гру",
      "playersHelp": "Зараз у грі гравців: {{count}}; місць не може бути менше.",
      "newPassword": "Новий пароль",
      "passwordPlaceholder": "Залиште порожнім, щоб не змінювати",
      "passwordHelp": "Літери, цифри, _ і -, до 16 символів. Гравці, що вже в грі, залишаються.",
      "saved": "Збережено ✓"
    }
  },
  "keys": {
    "space": "Пробіл"
  },
  "phases": {
    "lobby": "Лобі",
    "choosing": "Вибір питання",
    "media": "Завантаження питання",
    "showing": "Можна тиснути",
    "answering": "Відповідь",
    "reveal": "Відповідь",
    "secret_transfer": "Кіт у мішку",
    "stake_bidding": "Ставка · аукціон",
    "final_elimination": "Вибір теми",
    "final_bidding": "Фінал · ставки",
    "final_answering": "Фінал · відповіді",
    "final_reviewing": "Фінал · перевірка",
    "finished": "Гру завершено",
    "all_play_bidding": "Усі · ставки",
    "all_play_answering": "Відповідають усі",
    "all_play_reviewing": "Усі · перевірка"
  },
  "questionOpening": {
    "opening": "Відкриваємо питання",
    "waiting": "Очікування завантаження медіа всіма гравцями..."
  },
  "reasons": {
    "question_opening": "Відкриваємо питання — зачекайте завершення переходу",
    "wrong_role": "Це можуть лише гравці",
    "wrong_role_watch": "Ви глядач — глядачі не тиснуть кнопку",
    "wrong_phase": "Зараз недоступно",
    "not_your_turn": "Не ваш хід",
    "already_done": "Ви вже відповідали на це питання",
    "not_eligible": "Ви приєдналися після початку цього питання",
    "waiting_for_media": "Кнопка відкриється, коли питання завантажиться в усіх",
    "waiting_for_server": "Надсилаємо…",
    "connection_lost": "Перепідключення — дії призупинено",
    "paused": "Гра на паузі",
    "skipped": "Ви пропустили це питання",
    "false_start": "Ви натиснули зарано — зачекайте трохи"
  },
  "chips": {
    "offline": "офлайн",
    "picks": "обирає",
    "loading": "завантажує…",
    "answering": "відповідає",
    "passed": "пас",
    "givingAway": "віддає",
    "choosingPrice": "обирає ціну",
    "bidding": "ставить",
    "removing": "прибирає",
    "bidPlaced": "ставку зроблено",
    "answered": "відповів",
    "typing": "пише",
    "someone": "хтось"
  },
  "board": {
    "caption": "Табло раунду: {{round}}",
    "picker": "Обирає {{name}}",
    "cell": "{{theme}}, {{price}}",
    "played": "{{theme}}, {{price}}, уже зіграно",
    "editHint": "Натисніть на питання, щоб прибрати його з табло, або на закреслене, щоб повернути."
  },
  "question": {
    "region": "Питання",
    "image": "Зображення до питання",
    "audio": "Аудіо до питання",
    "getReady": "Приготуйтеся…",
    "mediaReady": "Питання завантажилося в {{ready}} з {{total}} гравців",
    "noContent": "Ведучий зачитає це питання вголос.",
    "noRiskHelp": "Без ризику: за неправильну відповідь бали не знімаються",
    "options": "Варіанти відповіді",
    "optionsSoon": "Варіанти з'являться за мить…",
    "showmanPreview": "Поки питання не завантажиться в усіх гравців, його бачите лише ви.",
    "mediaFailed": {
      "image": "Не вдалося завантажити зображення",
      "video": "Не вдалося завантажити відео",
      "audio": "Не вдалося завантажити аудіо"
    },
    "mediaFailedHelp": "Сервер файлів не відповідає. Ведучий може прочитати питання вголос або пропустити його.",
    "openFile": "Відкрити файл",
    "mediaLoading": "Завантаження…",
    "audioPlaying": "Слухайте",
    "audioWaiting": "Аудіо заграє, коли відкриється питання",
    "enableSound": "Натисніть, щоб увімкнути звук",
    "step": "Частина {{current}} з {{total}}",
    "stepsLabel": "Частини питання",
    "recap": "Питання: {{text}}",
    "audioEnded": "Завершено",
    "replay": "Повторити показ",
    "optionNumber": "Варіант {{n}}",
    "mediaTab": "Медіа",
    "textTab": "Текст",
    "scrollHint": "Прокрутіть, щоб прочитати далі",
    "expandOption": "Відкрити варіант {{n}}"
  },
  "showman": {
    "panel": "Бачите лише ви",
    "onlyYou": "Відповідь · бачите лише ви",
    "answer": "Правильна відповідь",
    "noAnswerText": "У паку немає тексту відповіді",
    "hint": "Підказка: {{hint}}",
    "answering": "Відповідає <player>{{name}}</player>:",
    "sayingOutLoud": "Відповідає вголос",
    "emptySubmission": "Текст відповіді не надійшов.",
    "alreadyAnswered": "Уже відповідали",
    "comment": "Інструкція ведучому",
    "alsoRight": "Теж правильно: {{answers}}",
    "notRight": "Неправильно: {{answers}}",
    "number": "Правильне число: {{number}}{{deviation}}",
    "autoChecked": "Гра автоматично перевіряє розпізнані відповіді."
  },
  "reveal": {
    "answer": "Відповідь",
    "gotIt": "<player>{{name}}</player> відповідає правильно · <points>{{points}}</points>",
    "nobody": "Ніхто не відповів правильно.",
    "correctPlayers": "Правильно відповіли: {{players}}",
    "correctCount": "Правильно: {{correct}}/{{total}}",
    "noSubmissions": "Ніхто не надіслав відповідь.",
    "unresolved": "Деякі відповіді ще не оцінено.",
    "playerFallback": "Гравець {{id}}",
    "submitted": "<player>{{name}}</player> відповів(ла): «{{answer}}»",
    "alsoRight": "Також приймається: <answers>{{answers}}</answers>",
    "authors": "Автор: {{names}}",
    "sources": "Джерело: {{list}}"
  },
  "secret": {
    "youPicked": "Вам випав кіт у мішку. Кому віддати питання?",
    "picked": "<player>{{name}}</player> отримує кота в мішку й обирає, хто відповідатиме.",
    "ruleAny": "Питання можна віддати будь-якому гравцю, зокрема собі. Відповідає лише він — без кнопки.",
    "ruleExcept": "Питання треба віддати іншому гравцю. Відповідає лише він — без кнопки.",
    "giveTo": "Віддати питання",
    "prices": "Варіанти вартості",
    "pickPriceYou": "Питання ваше — оберіть його вартість",
    "pickPrice": "<player>{{name}}</player> отримує питання й обирає вартість"
  },
  "stake": {
    "kicker": "Ставка · аукціон",
    "rules": "Питання отримує той, хто поставить найбільше, і відповідає сам. Стартова ціна {{start}}, максимум {{max}}.",
    "noLimit": "ваш рахунок",
    "bids": "Ставки за черговістю",
    "passed": "пас",
    "theirTurn": "його хід",
    "bid": "ставка",
    "waiting": "чекає"
  },
  "final": {
    "mediaTimedOut": "Не всі гравці встигли завантажити медіа. Питання вже почалося, тому частина вмісту може бути недоступна.",
    "themesTitle": "Теми фіналу",
    "themesHelp": "Гравці по черзі прибирають теми. Остання тема стане фінальним питанням.",
    "removed": "Прибрано",
    "remove": "Прибрати",
    "finalTheme": "Фінальна тема",
    "removeTheme": "Прибрати тему {{name}}",
    "themeRemoved": "{{name}}, прибрано",
    "theme": "Фінал · {{name}}",
    "bidPrompt": "Зробіть ставку, перш ніж побачите питання.",
    "bidPlaced": "ставку зроблено",
    "bidding": "ставить",
    "answered": "відповів",
    "typing": "пише",
    "answers": "Відповіді фіналу",
    "bid": "ставка",
    "noAnswer": "Немає відповіді",
    "judging": "Перевіряється",
    "autoLoss": "Немає відповіді · {{points}}"
  },
  "finished": {
    "wins": "Перемагає {{name}}!",
    "tie": "Нічия!",
    "noPlayers": "Гру завершено",
    "podium": "П'єдестал",
    "place": "{{n}} місце"
  },
  "judge": {
    "correct": "Правильно",
    "wrong": "Неправильно",
    "more": "Інші рішення",
    "double": "×2 {{points}}",
    "correctDoubleLabel": "Правильно, подвійні бали: +{{points}}",
    "wrongDoubleLabel": "Неправильно, подвійний штраф: −{{points}}",
    "skipZero": "Пропустити, 0"
  },
  "bid": {
    "quick": "Швидкі ставки",
    "slider": "Повзунок ставки",
    "detailsUnavailable": "Дані для ставки недоступні. Зачекайте на оновлення гри.",
    "afterAllIn": "Після ва-банку можна лише піти ва-банк або пасувати.",
    "noRegularBid": "Звичайна ставка недоступна.",
    "waitTimer": "Доступних ставок немає. Дочекайтеся таймера.",
    "amount": "Ваша ставка",
    "bid": "Поставити {{amount}}",
    "range": "Ставка {{min}} – {{max}}",
    "allIn": "Ва-банк {{amount}}",
    "pass": "Пас"
  },
  "admin": {
    "manage": "Керувати: {{name}}",
    "score": "Рахунок",
    "setScore": "Змінити рахунок",
    "scoreHelp": "Усі побачать зміну на табло.",
    "giveTurn": "Передати хід",
    "isTurn": "Зараз його хід",
    "toSpectators": "Перевести до глядачів",
    "kick": "Видалити з гри",
    "mute": "Вимкнути чат",
    "unmute": "Увімкнути чат",
    "muteHelp": "Гравець лишається в грі, але не може писати в чат.",
    "restrict": "Лишити глядачем",
    "unrestrict": "Дозволити грати знову",
    "restrictHelp": "Переводить у глядачі й не дає зайняти місце гравця.",
    "ban": "Заблокувати в цій грі",
    "banConfirm": "Так, заблокувати {{name}}",
    "banHelp": "Видаляє з гри без можливості повернутися."
  },
  "announce": {
    "correct": "{{name}} відповідає правильно, {{points}}",
    "wrong": "{{name}} помиляється, {{points}}",
    "skipped": "відповідь {{name}} пропущено, {{points}}",
    "yourTurn": "Ваш хід"
  },
  "dock": {
    "region": "Ваша дія",
    "next": "Що далі",
    "sending": "Надсилаємо…",
    "reconnecting": "Перепідключення",
    "offlineInfo": "Дії призупинено, доки ви не повернетеся",
    "paused": "Пауза",
    "choosing": {
      "yourTurn": "Ваш хід — обирайте",
      "pickInfo": "Оберіть будь-яку жовту клітинку на табло",
      "isPicking": "Обирає <player>{{name}}</player>",
      "showmanPicks": "Наступне питання обирає ведучий",
      "showmanStatus": "Наступним обирає <player>{{name}}</player>",
      "youPick": "Оберіть наступне питання",
      "showmanInfo": "Зачекайте на вибір гравця або оберіть замість нього",
      "pickAny": "Оберіть будь-яку клітинку на табло",
      "randomQuestion": "Випадкове питання",
      "noQuestions": "Не залишилося питань",
      "next": "Щойно питання оберуть, воно відкриється для всіх.",
      "nextYou": "Питання відкриється для всіх одразу після вашого вибору.",
      "unknownShowman": "Обирає гравець — або оберіть замість нього",
      "unknown": "Перший вибір",
      "unknownInfo": "Якщо зараз ваш хід, оберіть будь-яку клітинку на табло",
      "watching": "Ви дивитеся, як обирають питання"
    },
    "media": {
      "status": "Готові {{ready}} з {{total}} гравців",
      "finalWait": "Очікуємо, поки гравці завантажать фінальне питання.",
      "finalNext": "Фінальне питання почнеться, коли медіа буде готове.",
      "next": "Кнопка відкриється, щойно питання завантажиться в усіх гравців."
    },
    "showing": {
      "status": "Гравці можуть тиснути",
      "open": "Кнопка відкрита",
      "buzz": "Тисни!",
      "pass": "Пас",
      "unpass": "Скасувати пропуск",
      "wrongCost": "Неправильно: −{{points}}, і кнопка відкриється для інших",
      "wrongFree": "Неправильно: без штрафу",
      "next": "Відповідає той, хто натисне першим. Правильно: +{{points}}. {{wrong}}.",
      "showmanStatus": "Чекаємо, хто натисне",
      "revealAnswer": "Ніхто не знає — показати відповідь",
      "showmanNext": "Якщо час вийде і ніхто не натисне, відповідь покажеться автоматично.",
      "wait": "Кнопка відкриється після питання",
      "waitButton": "Зачекайте…",
      "earlyHint": "Якщо натиснути до відкриття кнопки, вона заблокується на 3 секунди.",
      "locked": "Фальстарт! Натиснути знову можна через {{seconds}} сек.",
      "nextWindow": "Усі, хто натиснув у перші частки секунди, мають рівні шанси. Правильно: +{{points}}. {{wrong}}.",
      "showmanWait": "Питання ще звучить — кнопка відкриється після нього",
      "openBuzzer": "Відкрити кнопку зараз",
      "showmanNextEarly": "Кнопка відкриється, коли питання закінчиться. Відкрийте її зараз, щоб гравці могли тиснути раніше.",
      "inDraw": "Ви в жеребкуванні…"
    },
    "answering": {
      "autoSubmitted": "<player>{{name}}</player> надіслав відповідь — очікуємо результат",
      "autoSubmittedHelp": "Відповідь надіслано. Зачекайте на результат або пропустіть без балів.",
      "questionLoading": "Очікуємо дані питання.",
      "autoWait": "Відповідає <player>{{name}}</player> — зачекайте на дію гравця",
      "autoWaitHelp": "Гравець має самостійно вибрати, ввести або позначити відповідь.",
      "autoWaitNext": "Якщо можливо, відповідь перевірять автоматично.",
      "judge": "Відповідає <player>{{name}}</player> — оцініть",
      "showmanNext": "Правильно: {{name}} отримує бали й обирає наступне. Неправильно: −{{points}}, і кнопка відкриється знову.",
      "showmanNextSingle": "На це питання відповідає лише {{name}}. У будь-якому разі далі буде відповідь.",
      "you": "Ви відповідаєте!",
      "pickOption": "Оберіть варіант або натисніть його номер",
      "typeLabel": "Ваша відповідь",
      "typePlaceholder": "Скажіть вголос або напишіть тут",
      "send": "Надіслати",
      "sent": "Надіслано ✓",
      "giveUp": "Здатися",
      "autoNext": "Розпізнані відповіді перевіряються автоматично. Якщо результат не надійде, ведучий може пропустити відповідь без балів.",
      "youNext": "Ведучий оцінить відповідь. За помилку знімуть бали, і кнопка відкриється для інших.",
      "choiceNext": "Розпізнані відповіді перевіряються автоматично. Якщо результат не надійде, ведучий може пропустити відповідь без балів.",
      "youNextSingle": "Ведучий оцінить відповідь. У будь-якому разі далі покажуть правильну відповідь.",
      "other": "Відповідає <player>{{name}}</player>",
      "wait": "Чекайте на рішення ведучого",
      "otherNext": "Якщо {{name}} помилиться, кнопка відкриється для всіх інших.",
      "otherNextSingle": "На це питання відповідає лише {{name}}.",
      "showmanChoice": "Гра перевірить відповідь {{name}}, якщо це можливо. Оцініть її, якщо потрібна перевірка.",
      "numberPlaceholder": "Введіть число"
    },
    "reveal": {
      "correct": "<player>{{name}}</player> відповідає правильно · <points>{{points}}</points>",
      "nobody": "Ось відповідь",
      "continue": "Далі",
      "info": "За мить повернемося до табло",
      "next": "Наступне питання обирає {{name}}.",
      "nextBoard": "Далі — табло."
    },
    "secret": {
      "choose": "Оберіть, хто відповідатиме",
      "giveQ": "Віддати <player>{{name}}</player>?",
      "otherChoosing": "<player>{{name}}</player> обирає, хто відповідатиме",
      "give": "Віддати: {{name}}",
      "pickFirst": "Спочатку оберіть гравця",
      "wait": "Зачекайте — питання може дістатися вам",
      "next": "Відповісти обов'язково: +{{points}}, якщо правильно, −{{points}}, якщо ні.",
      "nextNoPrice": "Відповідає лише обраний гравець.",
      "priceYou": "Оберіть вартість питання",
      "priceOther": "<player>{{name}}</player> обирає вартість",
      "priceWait": "Чекаємо, поки {{name}} обере вартість",
      "priceNext": "За правильну відповідь — обрана вартість, за неправильну — мінус стільки ж. Якщо час вийде, буде мінімальна.",
      "priceAbove": "Виберіть ціну питання зверху"
    },
    "stake": {
      "waitFor": "Чекаємо ставку від <player>{{name}}</player>",
      "watching": "Гравці роблять ставки — поки нічого робити не треба",
      "beat": "Ваша ставка — більше за {{amount}}",
      "open": "Ваша ставка",
      "next": "Найбільша ставка отримує питання й відповідає сама: + ставка, якщо правильно, − ставка, якщо ні. Пас остаточний."
    },
    "final": {
      "elimYou": "Ваш хід — приберіть одну тему",
      "elimOther": "<player>{{name}}</player> прибирає тему",
      "elimShowman": "<player>{{name}}</player> прибирає тему",
      "elimInfo": "Натисніть на тему, яка вам не потрібна",
      "elimNext_one": "Лишилася {{count}} тема — вона стане фінальним питанням.",
      "elimNext_few": "Лишилося {{count}} теми. Гравці прибирають по черзі, доки не лишиться одна.",
      "elimNext_many": "Лишилося {{count}} тем. Гравці прибирають по черзі, доки не лишиться одна.",
      "elimNext_other": "Лишилося {{count}} теми. Гравці прибирають по черзі, доки не лишиться одна.",
      "bidRange": "Ставка 1 – {{max}}",
      "placeBid": "Зробити ставку",
      "bidSubmitted": "Ставку подано",
      "bidLocked": "Ваша ставка: {{amount}}",
      "waitOthers": "Готові {{done}} з {{total}} — чекаємо на інших",
      "bidsIn": "Ставок: {{done}} з {{total}}",
      "bidShowman": "Гравці роблять приховані ставки",
      "bidNext": "Ставки приховані до перевірки. Гравці з 0 або менше пропускають фінал.",
      "sitOut": "Ви пропускаєте фінал",
      "typeAnswer": "Напишіть відповідь · ставка {{amount}}",
      "pointAnswer": "Оберіть точку · ставка {{amount}}",
      "pointNext": "Оберіть точку на зображенні, щоб відповісти. Якщо час сплине без відповіді, ставка програє.",
      "answerLabel": "Ваша відповідь у фіналі",
      "answerPlaceholder": "Напишіть відповідь",
      "submit": "Надіслати",
      "answerLocked": "Відповідь прийнято",
      "answersIn": "Відповідей: {{done}} з {{total}}",
      "answerShowman": "Гравці відповідають",
      "contentPlaying": "Показ питання",
      "contentWait": "Спершу перегляньте питання.",
      "contentNext": "Відповідати можна буде після показу питання.",
      "answerNext": "Відповіді покажуть під час перевірки. Коли час вийде, надішлеться те, що ви встигли написати.",
      "reviewStatus": "Перевірено {{done}} з {{total}}",
      "reviewShowman": "Оцініть кожну відповідь на сцені",
      "reviewWait": "Ведучий перевіряє відповіді",
      "reviewNext": "Рахунок оновлюється після кожної оцінки. Переможця покажуть після останньої."
    },
    "finished": {
      "place": "Ваше місце: {{n}}",
      "status": "Дякуємо за гру",
      "back": "До ігор",
      "next": "Проведіть нову гру з будь-яким паком або приєднайтеся до відкритої."
    },
    "allPlay": {
      "stakeWatch": "Гравці роблять ставки",
      "stakeLocked": "Ставку зроблено",
      "stakeNext": "Коли всі поставлять, питання покажеться всім.",
      "typeAnswer": "Напишіть відповідь — на це питання відповідають усі",
      "answerWatch": "Гравці пишуть відповіді",
      "answerNextStakeAuto": "Розпізнані відповіді перевіряються автоматично, нерозпізнані оцінює ведучий. За правильну ви виграєте ставку, за помилку — втрачаєте.",
      "answerNextNoRiskAuto": "Розпізнані відповіді перевіряються автоматично, нерозпізнані оцінює ведучий. За правильну — {{points}}, за помилку — без втрат.",
      "answerNextStake": "Коли час вийде, ведучий перевірить усі відповіді. Правильно — виграєте ставку, неправильно — втрачаєте.",
      "answerNextNoRisk": "Коли час вийде, ведучий перевірить усі відповіді. Правильно — {{points}}, неправильно — без втрат.",
      "reviewShowman": "Оцініть кожну відповідь на сцені",
      "reviewNext": "Коли всі відповіді оцінено, покажеться правильна."
    }
  },
  "errors": {
    "connection_lost": "Ви офлайн. Перепідключаємося…"
  },
  "notices": {
    "joined": "{{name}} приєднується",
    "back": "{{name}} повертається",
    "left": "{{name}} виходить — місце й рахунок збережено",
    "kicked": "{{name}} видалено з гри",
    "stakeWinner": "{{name}} виграє аукціон зі ставкою {{amount}} і відповідає сам",
    "secretTransfer": "Кіт у мішку дістається {{name}}",
    "scoreChanged": "Ведучий змінює рахунок {{name}} на {{score}}",
    "turnChanged": "Наступним обирає {{name}}"
  },
  "players": {
    "title": "Гравці та рахунок",
    "button": "Гравці",
    "scores": "Рахунок",
    "none": "Гравців ще немає.",
    "picksNext": "обирає наступним",
    "manage": "Керувати",
    "noShowman": "Зараз немає ведучого",
    "noSpectators": "Ніхто не дивиться.",
    "seat": "Зробити гравцем",
    "showmanHelp": "Натисніть «Керувати», щоб виправити рахунок, передати хід, перевести до глядачів або видалити гравця.",
    "viewAvatar": "Відкрити аватар {{name}}",
    "avatar": "Аватар {{name}}",
    "currentValue": "Вартість поточного питання",
    "lastValue": "Вартість останнього питання",
    "valueUnavailable": "Вартість попереднього питання невідома. Рахунок можна змінити в керуванні гравцем.",
    "addScore": "Додати {{amount}} гравцю {{name}}",
    "subtractScore": "Відняти {{amount}} у гравця {{name}}"
  },
  "upload": {
    "finalMedia": {
      "unavailable": "Не вдалося визначити тривалість файлу {{name}} для фінального питання. Перевірте файл і повторіть спробу.",
      "tooLong": "Тривалість {{name}} перевищує дві хвилини. Скоротіть файл або час його показу для фінального питання."
    },
    "pointImageDimensions": "Не вдалося визначити розміри першого зображення для відповіді точкою. Перевірте зображення та повторіть спробу.",
    "back": "Пакети",
    "title": "Завантажити пакет",
    "lead": "Додайте пакет SIGame .siq або експорт OpenQuester .oq. Ви побачите вміст ще до завантаження.",
    "signInFirst": "Увійдіть, щоб завантажувати пакети.",
    "guestTitle": "Гостьові акаунти не можуть завантажувати пакети",
    "guestHelp": "У пакета має бути власник, який може до нього повернутися. Увійдіть через Discord, і ваші пакети залишаться у вашому акаунті.",
    "discordUnavailable": "Вхід через Discord на цьому сайті ще не ввімкнено, тому завантаження тут недоступне.",
    "drop": "Перетягніть файл пакета сюди",
    "formats": "SIGame .siq (формати 4 і 5) або OpenQuester .oq.",
    "choose": "Вибрати файл",
    "reading": "Читаємо {{name}}…",
    "readErrors": {
      "wrongType": "Це не файл .siq або .oq.",
      "notZip": "Файл пошкоджений або не є архівом пакета.",
      "noContentXml": "У цьому .siq немає content.xml, тож читати нічого.",
      "badContentXml": "Опис пакета всередині цього .siq пошкоджений.",
      "noContentJson": "У цьому .oq немає content.json, тож читати нічого.",
      "badContentJson": "Опис пакета всередині цього .oq пошкоджений.",
      "generic": "Не вдалося прочитати файл.",
      "otherSource": "Це не той файл, з якого завантажили пакет, тож ним не можна завершити це завантаження. Завантажте його як новий пакет.",
      "allHtmlQuestions": "Після імпорту не залишилося придатних питань. Інші питання можуть містити відсутні медіафайли.",
      "ambiguousManifest": "Архів містить кілька суперечливих маніфестів пакета."
    },
    "format": {
      "siq": "Пакет SIGame",
      "oq": "Пакет OpenQuester"
    },
    "questionCount_one": "{{count}} питання",
    "questionCount_few": "{{count}} питання",
    "questionCount_many": "{{count}} питань",
    "questionCount_other": "{{count}} питання",
    "mediaCount_one": "{{count}} медіафайл · {{size}}",
    "mediaCount_few": "{{count}} медіафайли · {{size}}",
    "mediaCount_many": "{{count}} медіафайлів · {{size}}",
    "mediaCount_other": "{{count}} медіафайлу · {{size}}",
    "noQuestions": "У файлі немає питань, які можна зіграти, тож завантажувати нічого.",
    "warningsTitle_one": "Під час читання змінено {{count}} річ",
    "warningsTitle_few": "Під час читання змінено {{count}} речі",
    "warningsTitle_many": "Під час читання змінено {{count}} речей",
    "warningsTitle_other": "Під час читання змінено {{count}} речі",
    "warningsHelp": "Пакет усе одно завантажиться. Ці питання можуть відрізнятися від оригіналу.",
    "warnings": {
      "missingFile": "Медіафайлу {{detail}} немає в архіві, тому його пропущено.",
      "externalMedia": "Медіа за посиланням ({{detail}}) не можна завантажити, його пропущено.",
      "emptyQuestion": "Питання без тексту й медіа, тому його пропущено.",
      "noAnswer": "У питання немає відповіді. Ведучий оцінить без неї.",
      "choiceAsSimple": "У питанні з вибором менше двох варіантів, тому воно грає як звичайне.",
      "choiceCorrectUnresolved": "Потрібно виправити правильний варіант. Відкрийте питання в редакторі та оберіть його знову.",
      "unknownType": "Тип питання «{{detail}}» ще не підтримується і грає як звичайне.",
      "finalAsSimple": "Фінальний раунд не на останній позиції перетворено на звичайний. Перевірте питання та їхню вартість.",
      "extraFinalQuestions": "Імпортовано лише перше питання цієї фінальної теми; додаткових питань пропущено: {{detail}}. Перевірте вихідний архів.",
      "hashMismatch": "Медіафайл {{detail}} пошкоджений, його пропущено.",
      "htmlQuestionRemoved": "Непідтримуване HTML-питання видалено."
    },
    "showAll": "Показати всі {{count}}",
    "showFewer": "Показати менше",
    "upload": "Завантажити пакет",
    "another": "Вибрати інший файл",
    "progressLabel": "Перебіг завантаження",
    "creating": "Створюємо пакет…",
    "sending": "Завантажуємо медіа {{done}} з {{total}} · {{sent}} з {{size}}",
    "keepOpen": "Не закривайте сторінку, доки завантаження не завершиться.",
    "done": "Пакет завантажено",
    "doneHelp": "«{{title}}» готовий. Створіть гру з ним зараз або знайдіть його пізніше в Пакетах.",
    "viewPackage": "Переглянути пакет",
    "partial_one": "{{count}} медіафайл не завантажився",
    "partial_few": "{{count}} медіафайли не завантажилися",
    "partial_many": "{{count}} медіафайлів не завантажилися",
    "partial_other": "{{count}} медіафайлу не завантажилися",
    "retryFiles": "Повторити ці файли",
    "tryAgain": "Спробувати ще раз",
    "networkError": "Під час завантаження зник зв'язок. Перевірте мережу й спробуйте ще раз.",
    "serverRejected": "Сервер не прийняв пакет: {{message}}",
    "editFirst": "Редагувати перед завантаженням",
    "compress": {
      "label": "Медіа автоматично готуються до завантаження",
      "help": "Файли можуть бути стиснуті або перетворені на інший формат. Медіа, вже підготовлені в редакторі, та файли, які браузер не може перетворити, залишаться без змін.",
      "progress": "Стискаємо медіа: {{done}} з {{total}} · {{before}} → {{after}}",
      "saved": "Медіа стиснуто з {{before}} до {{after}}.",
      "before": "Поточний розмір медіа",
      "estimate": "Орієнтовно після стиснення",
      "estimating": "Оцінюємо…",
      "estimateHelp": "Приблизний розмір медіа, а не архіву. Результат може відрізнятися; для файлів, які не вдалося оцінити, враховано поточний розмір. Файли, вже наявні у сховищі, можуть не займати додаткове місце."
    },
    "checking": "Перевіряємо, що всі файли дійшли…",
    "fileType": {
      "image": "Зображення",
      "audio": "Звук",
      "video": "Відео"
    },
    "fileState": {
      "waiting": "У черзі",
      "uploading": "Завантажується",
      "done": "Завантажено",
      "failed": "Помилка"
    },
    "showAllFiles_one": "Показати {{count}} файл",
    "showAllFiles_few": "Показати всі {{count}} файли",
    "showAllFiles_many": "Показати всі {{count}} файлів",
    "showAllFiles_other": "Показати всі {{count}} файлу",
    "unfinished": "Завантажено {{uploaded}} з {{total}} медіафайлів",
    "unfinishedHelp": "Пакет збережено, але ніхто не зможе почати з ним гру, доки не завантажено всі медіа. Можна дозавантажити зараз або пізніше в розділі «Мої пакети».",
    "resumeLater": "Дозавантажити пізніше",
    "uploadAnyway": "Усе одно завантажити",
    "duplicates": {
      "title_one": "Цей пакет уже є в OpenQuester",
      "title_few": "Цей пакет уже є в OpenQuester ({{count}} рази)",
      "title_many": "Цей пакет уже є в OpenQuester ({{count}} разів)",
      "title_other": "Цей пакет уже є в OpenQuester ({{count}} рази)",
      "help": "Його завантажили з того самого файлу. Скористайтеся ним замість копії або завантажте ще раз, якщо так і задумано.",
      "yours": "Ваше завантаження · {{when}}",
      "by": "Від {{author}} · {{when}}",
      "resume": "Дозавантажити цей пакет",
      "open": "Відкрити"
    },
    "htmlRemoval": {
      "title": "Непідтримувані HTML-питання",
      "explanation_one": "HTML-питання не підтримуються. Для продовження потрібно видалити {{count}} питання. Оригінальний файл не зміниться.",
      "explanation_few": "HTML-питання не підтримуються. Для продовження потрібно видалити {{count}} питання. Оригінальний файл не зміниться.",
      "explanation_many": "HTML-питання не підтримуються. Для продовження потрібно видалити {{count}} питань. Оригінальний файл не зміниться.",
      "explanation_other": "HTML-питання не підтримуються. Для продовження потрібно видалити {{count}} питання. Оригінальний файл не зміниться.",
      "all": "Питань не залишиться, тому цей файл неможливо імпортувати.",
      "item": "{{round}} › {{theme}} › питання {{number}} › {{price}}",
      "cancel": "Скасувати",
      "confirm": "Видалити й продовжити"
    },
    "includesMedia": "Зображення, аудіо та відео з файлу теж завантажуються."
  },
  "editor": {
    "storageFailed": "Не вдалося оновити чернетки на цьому пристрої. Спробуйте ще раз.",
    "drafts": "Чернетки",
    "backToDrafts": "До чернеток",
    "cancel": "Скасувати",
    "optional": "(необов'язково)",
    "undo": "Скасувати дію",
    "redo": "Повторити",
    "export": "Експорт .oq",
    "exportHelp": "Завантажити пакет як файл .oq, який можна відкрити тут або в застосунку OpenQuester.",
    "savedAt": "Збережено в цьому браузері {{when}}",
    "notSaved": "Ще не збережено",
    "missing": "Цієї чернетки немає в цьому браузері",
    "missingHelp": "Чернетки зберігаються в браузері, де їх створили. Можливо, її видалили або створили на іншому пристрої.",
    "seconds_one": "{{count}} сек.",
    "seconds_few": "{{count}} сек.",
    "seconds_many": "{{count}} сек.",
    "seconds_other": "{{count}} сек.",
    "secondsShort": "сек.",
    "player": {
      "play": "Відтворити",
      "pause": "Пауза",
      "seek": "Позиція відтворення",
      "mute": "Вимкнути звук",
      "unmute": "Увімкнути звук",
      "volume": "Гучність",
      "fullscreen": "На весь екран",
      "fullscreenError": "Повноекранний режим недоступний.",
      "exitFullscreen": "Вийти з повноекранного режиму",
      "loading": "Завантаження медіа…",
      "error": "Не вдалося відтворити медіа."
    },
    "defaults": {
      "title": "Новий пакет",
      "round": "Раунд {{n}}",
      "theme": "Перша тема"
    },
    "home": {
      "title": "Редактор пакетів",
      "lead": "Створіть пакет з нуля або відкрийте файл .siq чи .oq, а потім опублікуйте його для гри.",
      "newTitle": "З нуля",
      "newHelp": "Один раунд з темою на п'ять питань.",
      "new": "Новий пакет",
      "importTitle": "Відкрити файл",
      "importHelp": "Пакет SIGame .siq або експорт OpenQuester .oq. Редагуйте його тут перед публікацією.",
      "import": "Відкрити .siq або .oq",
      "drafts": "Ваші чернетки",
      "draftsHelp": "Чернетки зберігаються в цьому браузері до публікації. Експортуйте .oq, щоб перенести на інший пристрій.",
      "noDrafts": "Чернеток поки немає.",
      "draftMeta": "Раундів: {{rounds}} · питань: {{questions}} · змінено {{when}}",
      "published": "опубліковано",
      "deleteDraft": "Видалити чернетку {{title}}",
      "deleteConfirm": "Видалити чернетку «{{title}}»? Її медіа теж буде видалено з цього браузера."
    },
    "outline": {
      "label": "Структура пакета",
      "details": "Про пакет",
      "rounds": "Раунди",
      "addRound": "Додати раунд",
      "untitled": "Без назви",
      "counts": "Тем: {{themes}} · питань: {{questions}}"
    },
    "board": {
      "roundOf": "Раунд {{n}} з {{total}}",
      "roundName": "Назва раунду",
      "roundNamePlaceholder": "Назвіть раунд",
      "roundType": "Тип раунду",
      "roundTypes": {
        "simple": "Звичайний",
        "final": "Фінал"
      },
      "oneFinal": "У пакеті один фінальний раунд, і він уже є.",
      "finalHelp": "У фіналі гравці обирають тему, роблять ставку й відповідають на одне питання. Кожна тема містить рівно одне питання без ціни.",
      "addTheme": "Додати тему",
      "roundActions": "Дії з раундом",
      "noThemes": "У цьому раунді ще немає тем",
      "noThemesHelp": "Тема — це рядок на табло. Додайте її, і вона одразу матиме п'ять питань для заповнення.",
      "themeName": "Назва теми",
      "themeNamePlaceholder": "Назвіть тему",
      "themeActions": "Дії з темою {{name}}",
      "dragTheme": "Перетягніть, щоб перемістити тему в інше місце чи раунд",
      "questionCount_one": "{{count}} питання",
      "questionCount_few": "{{count}} питання",
      "questionCount_many": "{{count}} питань",
      "questionCount_other": "{{count}} питання",
      "questionActions": "Дії з {{label}}",
      "emptyQuestion": "Порожнє питання",
      "noText": "Ще без тексту",
      "addQuestion": "Додати",
      "addQuestionTo": "Додати питання до {{name}}",
      "dropHere": "Перетягніть сюди",
      "needsFix": "Треба виправити",
      "check": "Варто переглянути"
    },
    "actions": {
      "edit": "Редагувати",
      "move": "Перемістити…",
      "moveTheme": "Перемістити тему…",
      "duplicate": "Дублювати",
      "delete": "Видалити",
      "deleteTheme": "Видалити тему",
      "deleteRound": "Видалити раунд"
    },
    "density": {
      "label": "Вигляд табло",
      "compact": "Компактні картки, питання при наведенні",
      "cards": "Картки з медіа та відповідями"
    },
    "inspector": {
      "label": "Вибране питання",
      "resize": "Змінити ширину панелі питання"
    },
    "playtest": {
      "title": "Інтерактивний перегляд гри",
      "description": "Локальна симуляція цього незбереженого питання. Справжня гра не створюється.",
      "loading": "Підготовка медіа питання…",
      "mediaError": "Не вдалося завантажити медіа питання. Перевірте файли й спробуйте знову.",
      "retry": "Спробувати знову",
      "fix": "Повернутися до редагування",
      "invalid": "Це питання ще не завершено.",
      "perspective": "Дивитися як",
      "player": "Гравець {{number}}",
      "showman": "Ведучий",
      "spectator": "Глядач",
      "continue": "Продовжити",
      "restart": "Почати знову",
      "pause": "Пауза",
      "resume": "Продовжити гру",
      "controls": "Керування симуляцією",
      "local": "Локальна перевірка чернетки запитання.",
      "settings": "Налаштування перевірки",
      "waiting": "Дочекайтеся сигналу або прискорте показ вмісту.",
      "legacy": "Перегляд використовує поточні розміри зображення. Збережене старе питання зберігає попередню поведінку сервера до повторної публікації.",
      "theme": "Тестова тема",
      "round": "Тестовий раунд",
      "final": "Фінальний раунд",
      "number": "Число",
      "deviation": "Допустиме відхилення відповіді має бути не меншим за нуль.",
      "stakeLimit": "Максимальна ставка для цього аукціону має бути не меншою за ціну питання.",
      "keepTheme": "Залишиться для перевірки",
      "targetTheme": "Тему «{{name}}» збережено для питання, яке перевіряється.",
      "finished": "Перевірку завершено. Почніть знову, щоб повторити.",
      "switchToPlayer": "Перемкніть перегляд на гравця, який може діяти.",
      "judgeAnswers": "Оцініть надіслані відповіді за допомогою елементів керування нижче.",
      "switchToShowman": "Перейдіть до ведучого, щоб оцінити надіслані відповіді."
    },
    "preview": {
      "mediaCount": "Медіафайлів: {{count}}",
      "mediaOnly": "Відповідь у медіа",
      "openFull": "Виберіть питання для повного перегляду.",
      "answer": "Відповідь",
      "pointAnswer": "Точка на зображенні",
      "pointUnavailable": "Точка або її зображення недоступні.",
      "noAnswer": "Відповіді ще немає",
      "noQuestion": "Ще немає тексту чи медіа",
      "hint": "Підказка ведучому",
      "comment": "Коментар",
      "maxBid": "Ставки до {{max}}",
      "allIn": "Можна ва-банк",
      "everyone": "грають усі",
      "back": "Назад",
      "readOnly": "Перегляд · раундів: {{rounds}} · питань: {{questions}} · лише читання"
    },
    "media": {
      "dragFile": "Перетягнути файл {{number}}, щоб змінити порядок",
      "moveEarlier": "Перемістити файл {{number}} раніше",
      "moveLater": "Перемістити файл {{number}} пізніше",
      "pointUndoConfirm": "Скасування змінить зображення для правильної точки. Поточну точку буде скинуто. Продовжити?",
      "sizeUnknown": "Розмір невідомий",
      "image": "Зображення",
      "audio": "Аудіо",
      "video": "Відео",
      "missing": "Файлу немає",
      "add": "Додати зображення, аудіо чи відео",
      "reading": "Читаємо…",
      "remove": "Прибрати файл",
      "show": "Показ",
      "dropMore": "Перетягніть сюди ще файли",
      "errors": {
        "mediaType": "{{name}} не є зображенням, аудіо чи відео.",
        "mediaSize": "{{name}} більший за 100 МБ."
      }
    },
    "form": {
      "title": "Питання за {{price}}",
      "finalTitle": "Фінальне питання",
      "description": "Редагуйте питання, відповідь і медіа.",
      "type": "Тип питання",
      "typeHelp": {
        "simple": "Відповідає перший, хто натиснув",
        "stake": "Гравці торгуються за право відповісти",
        "secret": "Передається іншому гравцю",
        "noRisk": "Без штрафу, бонусні бали",
        "choice": "Вибір з варіантів",
        "hidden": "Ціну приховано на табло"
      },
      "price": "Ціна",
      "text": "Текст питання",
      "textPlaceholder": "Що бачать гравці й читає ведучий",
      "questionMedia": "Показується з питанням",
      "questionMediaHelp": "Перетягніть сюди зображення, аудіо чи відео. Питанню потрібен текст або медіа.",
      "textFirst": "Спочатку текст, потім кожен файл по черзі",
      "answer": "Правильні відповіді",
      "answerHelp": "<strong>Кожна допустима відповідь — з нового рядка.</strong> Гравці побачать їх після оцінювання відповіді.",
      "hint": "Підказка ведучому",
      "hintHelp": "Бачить лише ведучий, щоб оцінювати близькі відповіді.",
      "answerMedia": "Показується з відповіддю",
      "answerMediaHelp": "Необов'язкові медіа, що з'являються разом із відповіддю.",
      "comment": "Коментар",
      "commentHelp": "Інструкція ведучому перед читанням питання.",
      "options": "Варіанти",
      "optionsHelp": "Від двох до восьми варіантів. Позначте правильний.",
      "option": "Варіант {{letter}}",
      "correct": "Правильний",
      "removeOption": "Прибрати варіант {{letter}}",
      "addOption": "Додати варіант",
      "settingsFor": "Налаштування: {{type}}",
      "maxBid": "Найвища ставка",
      "maxBidHelp": "Залиште порожнім, щоб дозволити ва-банк.",
      "stakeEveryone": "Усі роблять ставку та відповідають",
      "multiplier": "Множник ціни",
      "noRiskEveryone": "Грають усі",
      "transferTitle": "Кому можна передати",
      "transfer": {
        "any": "Будь-якому гравцю",
        "exceptCurrent": "Будь-кому, крім того, хто обирав"
      },
      "allowedPrices": "Ціни на вибір отримувача",
      "allowedPricesHelp": "Необов'язково: від 2 до 5 цін через кому. Порожньо — ціна з табло.",
      "showDelay": "Варіанти з'являються через (сек.)",
      "showAnswer": "Тривалість показу відповіді",
      "secondsUnit": "секунд",
      "revealRange": "Введіть тривалість від 2 до 30 секунд.",
      "revealMediaHelp": "Тривалість визначає медіа відповіді; це резервне значення не застосовується.",
      "preview": "Попередній перегляд",
      "save": "Зберегти",
      "saveShortcut": "Ctrl+Enter зберігає",
      "unsaved": "У цьому питанні є незбережені зміни.",
      "discard": "Відкинути зміни",
      "keepEditing": "Продовжити редагування",
      "rightAnswers": "Також зараховувати",
      "rightAnswersHelp": "<strong>Кожна відповідь — з нового рядка.</strong> Варіант, що збігається з будь-якою з цих відповідей, також вважається правильним.",
      "wrongAnswers": "Неправильні відповіді",
      "wrongAnswersHelp": "<strong>По одній у рядку.</strong> Часті помилки, щоб ведучому було простіше оцінювати. Гравці їх не бачать.",
      "authors": "Автори",
      "sources": "Джерела",
      "sourcesHelp": "По одному в рядку: посилання чи книги. Показуються разом із відповіддю.",
      "answerType": "Як відповідають гравці",
      "answerTypes": {
        "text": "Текст",
        "number": "Число",
        "point": "Точка на зображенні"
      },
      "answerTypeHelp": {
        "text": "Відповідь оцінює ведучий.",
        "number": "Число перевіряється автоматично.",
        "point": "Точка на зображенні перевіряється автоматично."
      },
      "answerNumber": "Правильне число",
      "answerNumberMissing": "Вкажіть правильне число",
      "deviation": "Допустима різниця",
      "deviationHelp": "0 — лише це число.",
      "pointHelp": "Натисніть на правильне місце на вибраному зображенні.",
      "radius": "Радіус відповіді",
      "radiusLoading": "Завантаження розмірів зображення…",
      "radiusValue": "{{percent}}% · радіус {{pixels}} пікс.",
      "radiusLegacy": "Цей радіус перевищує діапазон повзунка. Він залишиться незмінним, доки ви його не зміните.",
      "pointLegacy": "Ця опублікована точка використовує стару перевірку до повторної публікації через вебредактор.",
      "pointNeedsImage": "Спершу додайте зображення до питання."
    },
    "timeline": {
      "add": "Додати текстовий крок",
      "text": "Додатковий текст {{number}}",
      "earlier": "Перемістити крок {{number}} раніше",
      "later": "Перемістити крок {{number}} пізніше",
      "remove": "Видалити текстовий крок {{number}}",
      "mainFirstHelp": "Показується першим, перед медіа та іншими текстовими кроками.",
      "moveHandle": "Перетягніть для зміни порядку або скористайтеся клавішами зі стрілками",
      "moveStatus": "Переміщено на позицію {{number}}"
    },
    "move": {
      "questionTitle": "Перемістити питання",
      "themeTitle": "Перемістити тему",
      "round": "Раунд",
      "theme": "Тема",
      "noThemes": "У цьому раунді ще немає тем.",
      "position": "Місце",
      "atEnd": "У кінець",
      "before": "Перед {{name}}",
      "confirm": "Перемістити сюди"
    },
    "details": {
      "title": "Про пакет",
      "name": "Назва пакета",
      "namePlaceholder": "Назвіть пакет",
      "description": "Опис",
      "language": "Мова",
      "noLanguage": "Не вказано",
      "age": "Вікове обмеження",
      "tags": "Теги",
      "tagsPlaceholder": "кіно, музика, 90-ті",
      "tagsHelp": "Розділяйте теги комами. Вони допомагають знайти ваш пакет.",
      "authorsHelp": "По одному в рядку. Показуються на сторінці пакета."
    },
    "confirm": {
      "themeTitle": "Видалити тему?",
      "roundTitle": "Видалити раунд?",
      "themeBody_one": "«{{name}}» і {{count}} питання в ній буде видалено. Це можна скасувати.",
      "themeBody_few": "«{{name}}» і {{count}} питання в ній буде видалено. Це можна скасувати.",
      "themeBody_many": "«{{name}}» і {{count}} питань у ній буде видалено. Це можна скасувати.",
      "themeBody_other": "«{{name}}» і {{count}} питання в ній буде видалено. Це можна скасувати.",
      "roundBody_one": "«{{name}}» з усіма темами і {{count}} питанням буде видалено. Це можна скасувати.",
      "roundBody_few": "«{{name}}» з усіма темами і {{count}} питаннями буде видалено. Це можна скасувати.",
      "roundBody_many": "«{{name}}» з усіма темами і {{count}} питаннями буде видалено. Це можна скасувати.",
      "roundBody_other": "«{{name}}» з усіма темами і {{count}} питаннями буде видалено. Це можна скасувати."
    },
    "changes": {
      "renamed": "Перейменовано",
      "questionSaved": "Питання збережено",
      "questionAdded": "Питання додано",
      "questionMoved": "Переміщено до {{to}}",
      "questionDeleted": "Питання видалено",
      "themeAdded": "Тему додано",
      "themeMoved": "Тему переміщено до {{to}}",
      "themeDeleted": "Тему видалено",
      "roundAdded": "Раунд додано",
      "roundMoved": "Раунд переміщено",
      "roundDeleted": "Раунд видалено",
      "roundType": "Тип раунду змінено",
      "duplicated": "Продубльовано",
      "detailsSaved": "Збережено",
      "pricesSet": "Ціни задано",
      "questionsPasted": "Питання додано"
    },
    "empty": {
      "title": "Порожній пакет",
      "help": "Додайте раунд, щоб почати. Раунд містить теми, а тема — питання."
    },
    "health": {
      "good": "Готово до публікації",
      "needsAttention": "Можна публікувати, але дещо варто переглянути",
      "broken_one": "{{count}} проблема, яку треба виправити перед публікацією",
      "broken_few": "{{count}} проблеми, які треба виправити перед публікацією",
      "broken_many": "{{count}} проблем, які треба виправити перед публікацією",
      "broken_other": "{{count}} проблеми, які треба виправити перед публікацією"
    },
    "severity": {
      "critical": "Треба виправити ({{count}})",
      "warning": "Варто переглянути ({{count}})",
      "info": "Поради ({{count}})"
    },
    "status": {
      "good_one": "Готово до публікації · {{count}} питання",
      "good_few": "Готово до публікації · {{count}} питання",
      "good_many": "Готово до публікації · {{count}} питань",
      "good_other": "Готово до публікації · {{count}} питання",
      "review": "Переглянути"
    },
    "publish": {
      "open": "Опублікувати",
      "title": "Публікація пакета",
      "publish": "Опублікувати в OpenQuester",
      "help": "Публікація завантажує пакет і медіа, щоб ви могли проводити з ним ігри.",
      "blocked_one": "Спершу виправте проблему вище. Натисніть на неї, щоб перейти.",
      "blocked_few": "Спершу виправте {{count}} проблеми вище. Натисніть на будь-яку, щоб перейти.",
      "blocked_many": "Спершу виправте {{count}} проблем вище. Натисніть на будь-яку, щоб перейти.",
      "blocked_other": "Спершу виправте {{count}} проблеми вище. Натисніть на будь-яку, щоб перейти.",
      "sending": "Завантаження медіа {{done}} з {{total}}",
      "doneHelp": "Запустіть гру з ним зараз або знайдіть його пізніше в розділі «Пакети». Чернетка лишається тут для змін; повторна публікація оновлює цей пакет (можна також опублікувати його як новий).",
      "saveChanges": "Зберегти зміни в опублікованому пакеті",
      "publishAsNew": "Опублікувати як новий пакет",
      "notYours": "Змінювати пакет може лише його автор. Опублікуйте його як новий пакет."
    },
    "issues": {
      "noTitle": "У пакета немає назви.",
      "noRounds": "У пакеті немає раундів.",
      "roundNoName": "У раунду немає назви.",
      "roundNoThemes": "У раунді немає тем.",
      "themeNoName": "У теми немає назви.",
      "themeNoQuestions": "У темі немає питань.",
      "questionEmpty": "У питання немає тексту чи медіа.",
      "noPrice": "У питання немає ціни.",
      "priceRange": "Ціна має бути від 0 до {{max}}.",
      "missingMedia": "Медіафайлу немає в цьому браузері. Додайте його знову.",
      "choiceOptions": "Питанню з вибором потрібно від 2 до 8 варіантів (зараз {{count}}).",
      "choiceEmptyOption": "Один із варіантів без тексту.",
      "choiceNoCorrect": "Жоден варіант не позначено правильним.",
      "choiceCorrectUnresolved": "Оберіть правильний варіант знову перед публікацією.",
      "secretPrices": "Вкажіть від 2 до 5 цін для отримувача або залиште список порожнім (зараз {{count}}).",
      "multipleFinals": "Фінальним може бути лише один раунд.",
      "finalNotLast": "Фінальний раунд має бути останнім.",
      "finalOneQuestion": "Фінальна тема містить рівно одне питання (зараз {{count}}).",
      "finalTypeIgnored": "Фінальні питання завжди звичайні; тип ігнорується.",
      "noAnswer": "У питання немає відповіді. Ведучий оцінюватиме без неї.",
      "longText": "Текст дуже довгий і може не вміститися на екрані.",
      "noLanguage": "Вкажіть мову, щоб гравцям було легше знайти пакет.",
      "noDescription": "Додайте короткий опис.",
      "noTags": "Додайте кілька тегів.",
      "numberAnswerMissing": "Відповідь-число без правильного числа",
      "pointAnswerMissing": "Відповідь-точка без зображення або правильного місця"
    },
    "tools": {
      "pricesTitle": "Задати ціни в раунді",
      "pricesHelp": "Усі теми раунду отримають однакові ціни, починаючи з першої.",
      "firstPrice": "Перша ціна",
      "step": "Крок",
      "pricesPreview": "Ціни: {{prices}}…",
      "applyPrices": "Задати ціни",
      "pasteTitle": "Вставити питання текстом",
      "pasteHelp": "Кожен блок — тема: назва в першому рядку, далі по питанню в рядку, відповідь після «|» або « — ». Порожній рядок починає наступну тему. Число на початку рядка — ціна.",
      "pasteLabel": "Питання",
      "pastePlaceholder": "Столиці\n100. Столиця Франції? | Париж\n200. Столиця Японії? | Токіо\n\nПланети\n100. Червона планета? | Марс",
      "pasteSummary": "Тем: {{themes}}, питань: {{questions}}.",
      "pasteMissing_one": "У {{count}} питання поки немає відповіді.",
      "pasteMissing_few": "У {{count}} питань поки немає відповіді.",
      "pasteMissing_many": "У {{count}} питань поки немає відповіді.",
      "pasteMissing_other": "У {{count}} питань поки немає відповіді.",
      "pasteAdd": "Додати до раунду",
      "searchTitle": "Пошук у пакеті",
      "searchPlaceholder": "Питання, відповідь або тема",
      "searchCount_one": "Знайдено {{count}} питання",
      "searchCount_few": "Знайдено {{count}} питання",
      "searchCount_many": "Знайдено {{count}} питань",
      "searchCount_other": "Знайдено {{count}} питань",
      "noText": "(без тексту)"
    },
    "saveFailed": "Зміни не збережено на цьому пристрої (можливо, сховище заповнене). Вони залишаються в цій вкладці: спробуйте ще раз або експортуйте файл.",
    "saveRetry": "Зберегти ще раз",
    "importReportHide": "Сховати звіт",
    "exportMediaFailed": "Не вдалося експортувати: файл {{name}} не завантажився зі сховища. Перевірте з’єднання і спробуйте ще раз."
  },
  "panels": {
    "pin": "Закріпити: {{name}}",
    "unpin": "Відкріпити: {{name}}",
    "close": "Закрити: {{name}}",
    "pinHelp": "Тримати панель відкритою поруч із грою, навіть після перезавантаження",
    "unpinHelp": "Закріплено на цьому пристрої. Натисніть, щоб відкріпити"
  },
  "adminPanel": {
    "title": "Адмінка",
    "overview": "Огляд",
    "users": "Користувачі",
    "system": "Система",
    "noAccess": "Ця сторінка лише для адміністраторів.",
    "noAccessHelp": "У вашого акаунта немає доступу адміністратора. Попросіть адміністратора, якщо він потрібен.",
    "loadFailed": "Не вдалося завантажити. Спробуйте ще раз.",
    "totalUsers": "Користувачі",
    "activeUsers": "Активні",
    "guests": "Гості",
    "deletedUsers": "Видалені",
    "bannedUsers": "Заблоковані",
    "uptime": "Час роботи сервера",
    "redis": "Redis",
    "redisKeys_one": "{{count}} ключ",
    "redisKeys_few": "{{count}} ключі",
    "redisKeys_many": "{{count}} ключів",
    "redisKeys_other": "{{count}} ключа",
    "down": "Не працює",
    "recentUsers": "Нові користувачі",
    "guest": "Гість",
    "search": "Пошук за ім'ям, логіном або email",
    "status": "Статус",
    "anyStatus": "Будь-який",
    "statusActive": "Активний",
    "statusBanned": "Заблокований",
    "statusDeleted": "Видалений",
    "type": "Тип",
    "typeAll": "Усі",
    "typeRegistered": "Зареєстровані",
    "typeGuest": "Гості",
    "actionFailed": "Не вийшло. Спробуйте ще раз.",
    "noUsers": "Нікого не знайдено.",
    "mutedUntil": "Без чату до {{date}}",
    "mute": "Вимкнути чат…",
    "unmute": "Увімкнути чат",
    "forHours_one": "На {{count}} годину",
    "forHours_few": "На {{count}} години",
    "forHours_many": "На {{count}} годин",
    "forHours_other": "На {{count}} години",
    "forWeek": "На тиждень",
    "ban": "Заблокувати",
    "unban": "Розблокувати",
    "confirmBan": "Підтвердити блокування",
    "delete": "Видалити",
    "confirmDelete": "Підтвердити видалення",
    "restore": "Відновити",
    "noHealthAccess": "Ваш акаунт не може переглядати стан системи.",
    "ping": "API",
    "ok": "OK",
    "eventLoop": "Затримка event loop",
    "redisMemory": "Пам'ять Redis",
    "redisKeysLabel": "Ключі Redis",
    "memory": "Пам'ять сервера",
    "refresh": "Оновити",
    "packages": "Пакети",
    "games": "Ігри",
    "role": "Роль",
    "roleUser": "Користувач",
    "roleModerator": "Модератор",
    "roleAdmin": "Адміністратор",
    "roleHelp": {
      "user": "Без доступу до адмін-панелі.",
      "moderator": "Модерує людей, ігри та пакети. За потреби познач додаткові дозволи нижче.",
      "admin": "Усе, зокрема ролі та дозволи."
    },
    "permissions": "Дозволи",
    "perm": {
      "get_all_users": "Бачити список користувачів",
      "get_another_user": "Бачити будь-який профіль",
      "change_another_user": "Редагувати будь-який профіль",
      "delete_another_user": "Видаляти й відновлювати акаунти",
      "delete_file": "Видаляти завантажені файли",
      "delete_package": "Видаляти будь-який пакет",
      "edit_package": "Редагувати будь-який пакет",
      "manage_permissions": "Змінювати ролі й дозволи",
      "admin_panel_access": "Відкривати адмін-панель",
      "view_system_health": "Бачити стан сервера",
      "view_users_info": "Бачити дані й статистику користувачів",
      "ban_users": "Банити й розбанювати",
      "mute_player": "Вимикати й вмикати чат",
      "manage_games": "Модерувати ігри (видаляти людей, пауза, закриття)",
      "view_system_logs": "Читати логи сервера",
      "manage_storage": "Змінювати ліміти сховища"
    },
    "savePermissions": "Зберегти",
    "editRole": "Роль…",
    "gameSearch": "Пошук ігор за назвою",
    "noGames": "Зараз ігор немає.",
    "gameFinished": "Завершена",
    "gamePaused": "На паузі",
    "playersCount": "{{count}}/{{max}} гравців",
    "manage": "Керувати",
    "gameGone": "Ця гра завершилась або її закрили.",
    "packageName": "Пакет: {{title}}",
    "nobodyInGame": "У цій грі нікого немає.",
    "people": "Люди в цій грі",
    "resume": "Продовжити",
    "pause": "Пауза",
    "openGame": "Відкрити гру",
    "closeGame": "Закрити гру",
    "confirmCloseGame": "Підтвердити: закрити для всіх",
    "closeGameHelp": "Усіх у грі буде повернуто на головну, а гру видалено.",
    "offline": "Вийшов або не в мережі",
    "remove": "Видалити",
    "confirmRemove": "Підтвердити видалення",
    "removeNamed": "Видалити {{name}}",
    "noPackages": "Пакетів не знайдено.",
    "byAuthor": "автор {{name}}",
    "packageSize": "раундів: {{rounds}}, питань: {{questions}}",
    "edit": "Редагувати",
    "deleteNamed": "Видалити {{name}}",
    "storage": "Сховище"
  },
  "myPackages": {
    "title": "Мої пакети",
    "guest": "Гостьові акаунти не можуть мати пакети. Увійдіть через Discord, щоб публікувати й керувати своїми.",
    "empty": "Ви ще не опублікували жодного пакета. Створіть його в редакторі або завантажте файл .siq чи .oq.",
    "published": "опубліковано {{when}}",
    "host": "Провести",
    "edit": "Редагувати",
    "opening": "Відкриваємо…",
    "delete": "Видалити",
    "confirmDelete": "Так, видалити",
    "deleteHelp": "Видалення прибирає пакет для всіх. Ігри, що вже тривають, зберігають свою копію.",
    "deleteFailed": "Не вдалося видалити пакет. Спробуйте ще раз.",
    "openFailed": "Не вдалося відкрити пакет у редакторі. Спробуйте ще раз.",
    "link": "Мої пакети"
  },
  "storage": {
    "loadFailed": "Не вдалося завантажити використання сховища.",
    "title": "Сховище",
    "used": "Використано {{used}} з {{quota}}",
    "usedNoLimit": "Використано {{used}}, без обмеження",
    "almostFull": "Ви майже досягли ліміту. Увімкніть стиснення медіа або видаліть непотрібні пакети.",
    "full": "Ви досягли ліміту. Видаліть непотрібні пакети або попросіть адміністратора про більше місця.",
    "bucket": "Усе сховище",
    "bucketFiles_one": "{{count}} збережений файл",
    "bucketFiles_few": "{{count}} збережені файли",
    "bucketFiles_many": "{{count}} збережених файлів",
    "bucketFiles_other": "{{count}} збережених файлів",
    "groupsTitle": "Ліміти за групами",
    "groupsHelp": "У мегабайтах; залиште поле порожнім, щоб не обмежувати. Файл, яким користуються кілька людей, рахується для кожного, а сховище зберігає одну копію.",
    "usersTitle": "Хто використовує найбільше",
    "noUsers": "Ще ніхто нічого не зберіг.",
    "noLimit": "Без ліміту",
    "save": "Зберегти",
    "saved": "Збережено",
    "ownQuota": "Власний ліміт",
    "ownQuotaLabel": "Ліміт сховища для {{name}}",
    "groupDefault": "Ліміт групи",
    "groups": {
      "guest": "Гості",
      "user": "Гравці",
      "moderator": "Модератори",
      "admin": "Адміністратори"
    },
    "fields": {
      "userQuotaBytes": "Усього на людину",
      "packageBytes": "Один пакет",
      "imageBytes": "Одне зображення",
      "audioBytes": "Один аудіофайл",
      "videoBytes": "Одне відео"
    },
    "projected": "Цей пак: орієнтовно +{{size}}.",
    "projectedOverQuota": "Пак може потребувати ще {{size}} і перевищити ліміт. Доступне місце буде перевірено під час завантаження.",
    "projectedUsage": "Вже зайнято {{used}}; цей пак може додати {{pending}}."
  },
  "allPlay": {
    "kickerStake": "Ставка для всіх",
    "kickerNoRisk": "Без ризику для всіх",
    "ruleStake": "Усі роблять ставку й пишуть відповідь. Правильно — виграєте ставку, неправильно — втрачаєте. Ставка до {{max}}.",
    "ruleNoRisk": "Усі пишуть відповідь. Правильно — {{points}}, неправильно — без втрат.",
    "stakePrompt": "Зробіть ставку — її ніхто не побачить, доки не прийдуть відповіді",
    "players": "Гравці"
  },
  "point": {
    "pick": "Натисніть, де відповідь",
    "picture": "Зображення питання",
    "pictureWaiting": "Зачекайте, поки з’явиться потрібне зображення.",
    "pictureUnavailable": "Потрібне зображення недоступне. Попросіть ведучого пропустити відповідь.",
    "prompt": "Натисніть на потрібне місце на зображенні",
    "cursor": "Курсор: {{x}}% зліва, {{y}}% згори. Стрілки рухають його, Enter обирає.",
    "pickedDescription": "Ваша позначка: {{x}}% ширини зображення зліва, {{y}}% висоти зверху.",
    "answerDescription": "{{name}} вибрав точку: {{x}}% ширини зображення зліва, {{y}}% висоти зверху.",
    "finalPictureUnavailable": "Зображення для відповіді недоступне. Надіслати відповідь точкою неможливо.",
    "targetDescription": "Правильна точка: {{x}}% ширини зображення зліва, {{y}}% його висоти згори. Радіус допуску: {{radius}}% ширини зображення.",
    "imageDimensions": "Розміри зображення: {{width}} на {{height}} пікселів.",
    "imageDimensionsUnavailable": "Розміри зображення ще недоступні."
  },
  "stats": {
    "title": "Ваші ігри",
    "seeLeaderboard": "Відкрити рейтинг",
    "loadFailed": "Не вдалося завантажити статистику.",
    "noGames": "Дограйте гру як гравець, і результати з'являться тут.",
    "games": "Ігри",
    "wins": "Перемоги",
    "totalScore": "Усього очок",
    "bestScore": "Найкраща гра",
    "accuracy": "Правильні відповіді",
    "answers": "Усього правильних відповідей: {{right}}, неправильних: {{wrong}}.",
    "recent": "Останні ігри",
    "won": "Перемога",
    "place": "Місце {{place}} з {{players}}",
    "played": "Зіграно"
  },
  "leaderboard": {
    "title": "Рейтинг",
    "help": "Гравці за кількістю перемог, потім за сумою очок. Гостьові акаунти не показуються.",
    "period": "Період",
    "periods": {
      "week": "За тиждень",
      "month": "За місяць",
      "all": "За весь час"
    },
    "loadFailed": "Не вдалося завантажити рейтинг.",
    "empty": "За цей період ще ніхто не дограв гру.",
    "player": "Гравець",
    "you": "ви"
  },
  "report": {
    "open": "З питанням щось не так?",
    "title": "Поскаржитися на питання",
    "help": "Автор пакета побачить вашу нотатку і зможе виправити питання.",
    "reason": "Що не так?",
    "reasons": {
      "wrong_answer": "Неправильна відповідь",
      "broken_media": "Не працює зображення, звук чи відео",
      "offensive": "Образливе питання",
      "other": "Інше"
    },
    "comment": "Подробиці (необов'язково)",
    "commentPlaceholder": "Наприклад, правильна відповідь і джерело",
    "send": "Надіслати",
    "sent": "Дякуємо, автор побачить вашу скаргу.",
    "already": "Ви вже поскаржилися на це питання.",
    "failed": "Не вдалося надіслати скаргу. Спробуйте ще раз."
  },
  "reports": {
    "short": "Скарги",
    "button": "Скарги, відкритих: {{n}}",
    "title": "Скарги на «{{title}}»",
    "help": "Що позначили гравці під час ігор. Виправте питання в редакторі й позначте скаргу вирішеною.",
    "noText": "Питання без тексту",
    "resolve": "Вирішено",
    "reopen": "Відкрити знову"
  },
  "resume": {
    "title": "Завершити завантаження",
    "notYours": "Завершити завантаження може лише автор пакета.",
    "notFound": "Цього пакета вже не існує.",
    "done": "Усі медіа завантажено",
    "doneHelp_one": "Його {{count}} медіафайл у сховищі, тож пакет готовий до гри.",
    "doneHelp_few": "Усі {{count}} медіафайли в сховищі, тож пакет готовий до гри.",
    "doneHelp_many": "Усі {{count}} медіафайлів у сховищі, тож пакет готовий до гри.",
    "doneHelp_other": "Усі {{count}} медіафайлу в сховищі, тож пакет готовий до гри.",
    "notInFile_one": "{{count}} відсутнього файлу немає у вибраному файлі. Виберіть файл, з якого завантажували цей пакет.",
    "notInFile_few": "{{count}} відсутніх файлів немає у вибраному файлі. Виберіть файл, з якого завантажували цей пакет.",
    "notInFile_many": "{{count}} відсутніх файлів немає у вибраному файлі. Виберіть файл, з якого завантажували цей пакет.",
    "notInFile_other": "{{count}} відсутнього файлу немає у вибраному файлі. Виберіть файл, з якого завантажували цей пакет.",
    "otherPackage": "Ви вибрали «{{picked}}», а це «{{title}}». Виберіть файл, з якого завантажували цей пакет.",
    "stashAll_one": "У цьому браузері ще зберігся відсутній файл з першої спроби.",
    "stashAll_few": "У цьому браузері ще збереглися всі {{count}} відсутні файли з першої спроби.",
    "stashAll_many": "У цьому браузері ще збереглися всі {{count}} відсутніх файлів з першої спроби.",
    "stashAll_other": "У цьому браузері ще збереглися всі {{count}} відсутнього файлу з першої спроби.",
    "stashSome": "У цьому браузері ще є {{count}} з {{total}} відсутніх файлів з першої спроби. Завантажте їх зараз, а для решти виберіть файл пакета.",
    "uploadStashed_one": "Завантажити {{count}} файл",
    "uploadStashed_few": "Завантажити {{count}} файли",
    "uploadStashed_many": "Завантажити {{count}} файлів",
    "uploadStashed_other": "Завантажити {{count}} файлу",
    "pickHelp": "Виберіть той самий файл .siq або .oq ще раз. Завантажаться лише відсутні медіа."
  },
  "roundTransition": {
    "title": "Наступний раунд",
    "description": "Раунд {{n}} — {{name}}",
    "firstTitle": "Перший раунд"
  },
  "skipRound": {
    "title": "Перейти до наступного раунду?",
    "help_one": "На полі ще {{count}} питання. Його не зіграють.",
    "help_few": "На полі ще {{count}} питання. Їх не зіграють.",
    "help_many": "На полі ще {{count}} питань. Їх не зіграють.",
    "help_other": "На полі ще {{count}} питання. Їх не зіграють.",
    "helpEmpty": "Наступний раунд почнеться одразу.",
    "confirm": "Пропустити раунд"
  },
  "discordActivity": {
    "connecting": "Підключення до Discord…",
    "findingGame": "Шукаємо гру цього дзвінка…",
    "retry": "Спробувати ще раз",
    "pickTitle": "Оберіть пакет для цього дзвінка",
    "pickHint": "Хто обере першим, той веде гру. Решта учасників дзвінка приєднаються автоматично.",
    "search": "Пошук пакетів",
    "noPackages": "Пакетів не знайдено.",
    "gameReady": "{{host}} веде гру цього дзвінка.",
    "joinGame": "Приєднатися до гри",
    "errors": {
      "not_configured": "Цей сервер не налаштований для роботи як Discord Activity.",
      "auth_failed": "Не вдалося увійти через Discord на кроці: {{step}}",
      "timeout": "Discord не відповів на кроці: {{step}}",
      "settings": "Не вдалося зв'язатися з сервером OpenQuester."
    },
    "steps": {
      "handshake": "Підключення до Discord…",
      "authorize": "Чекаємо на дозвіл Discord…",
      "sign_in": "Вхід до OpenQuester…",
      "authenticate": "Завершуємо вхід через Discord…"
    },
    "rejoinGame": "Повернутися до гри",
    "otherGames": "Інші ігри",
    "gameCode": "Код або посилання на гру",
    "joinByCode": "Приєднатися",
    "noOtherGames": "Зараз немає інших відкритих ігор.",
    "presence": {
      "lobby": "У лобі",
      "paused": "Пауза",
      "round": "{{round}}",
      "finished": "Гру завершено",
      "lobbyDetails": "Вікторина OpenQuester",
      "choosing": "Обирає гру"
    }
  },
  "mediaEditor": {
    "title": "Редагування медіа",
    "edit": "Редагувати",
    "loading": "Підготовка медіа…",
    "queue": "Файл {{index}} із {{total}}",
    "cancelProcessing": "Скасувати обробку",
    "processing": "Обробка медіа…",
    "retry": "Повторити",
    "discardPrompt": "Скасувати ці зміни медіа?",
    "skip": "Пропустити файл",
    "remaining": "Додати решту без змін",
    "unchanged": "Використати без змін",
    "save": "Зберегти медіа",
    "saveQuestion": "Зберегти запитання",
    "saveDetails": "Зберегти дані пакета",
    "saveNext": "Зберегти й далі",
    "imageTools": "Інструменти зображення",
    "select": "Вибрати / перемістити",
    "pen": "Перо",
    "arrow": "Стрілка",
    "rectangle": "Прямокутник",
    "text": "Текст",
    "blur": "Розмити ділянку",
    "undo": "Скасувати зміну медіа",
    "redo": "Повторити зміну",
    "canvas": "Попередній перегляд. Малюйте інструментами панелі; виберіть позначку та переміщуйте клавішами зі стрілками.",
    "fit": "Вмістити у вікно",
    "compare": "Утримуйте для оригіналу",
    "updating": "Оновлення кінцевого перегляду…",
    "rotateLeft": "Повернути ліворуч",
    "rotateRight": "Повернути праворуч",
    "wholeBlur": "Розмиття всього зображення",
    "quality": "Якість результату",
    "small": "Малий файл",
    "balanced": "Збалансована",
    "high": "Висока якість",
    "color": "Колір малювання",
    "textSize": "Розмір тексту",
    "strength": "Сила розмиття",
    "stroke": "Товщина лінії",
    "annotation": "Вибрана позначка",
    "delete": "Видалити позначку",
    "waveform": "Звукова хвиля",
    "start": "Початок",
    "end": "Кінець",
    "position": "Позиція відтворення",
    "pause": "Призупинити перегляд",
    "duration": "Результат: {{duration}}",
    "removeAudio": "Видалити звук",
    "noAudio": "Це відео не має звуку",
    "fadeIn": "Плавний початок",
    "fadeOut": "Плавне завершення",
    "fadeInSeconds": "Тривалість плавного початку в секундах",
    "fadeOutSeconds": "Тривалість плавного завершення в секундах",
    "visualUnavailable": "Перегляд часової шкали недоступний. Можна скористатися полями часу.",
    "choiceImage": "Зображення варіанта {{letter}}",
    "logo": "Зображення пакета",
    "errors": {
      "mediaSize": "Файл перевищує ліміт редактора 100 МБ.",
      "mediaType": "Виберіть зображення, аудіо або відео, яке підтримує це поле.",
      "unsupported": "Цей браузер не може обробити вибрані доріжки. Спробуйте Chrome чи Edge на комп’ютері або використайте файл без змін.",
      "unsupportedImage": "Це зображення або браузер не підтримує редагування. Анімовані зображення та SVG залишаються без змін.",
      "blurUnsupported": "Розмиття недоступне в цьому браузері.",
      "downloadFailed": "Не вдалося завантажити вихідний файл зі сховища. Перевірте з'єднання й повторіть спробу; вкладення не змінено.",
      "downloadCorrupt": "Завантажений файл не збігається з файлом у паку. Повторіть спробу; вкладення не змінено.",
      "processingFailed": "Не вдалося обробити медіа. Ваші зміни збережено в редакторі; повторіть спробу або використайте файл без змін.",
      "trim": "Початок має бути раніше за кінець і в межах файлу. Формат — хвилини:секунди (наприклад, 01:23.50)."
    },
    "zoom": "Масштаб перегляду",
    "zoomIn": "Збільшити",
    "zoomOut": "Зменшити",
    "actualSize": "Показати у масштабі 100%",
    "crop": "Обрізати",
    "cropHelp": "Виділіть область, яку хочете залишити, та застосуйте обрізання. Нижче — відсотки від початкового зображення.",
    "cropx": "Зліва (%)",
    "cropy": "Згори (%)",
    "cropwidth": "Ширина (%)",
    "cropheight": "Висота (%)",
    "applyCrop": "Застосувати обрізання",
    "resetCrop": "Скинути обрізання",
    "trimTitle": "Залишити фрагмент",
    "trimHelp": "Виберіть точку на таймлайні й обріжте все ліворуч або праворуч від неї. Точний час можна змінити нижче.",
    "startTime": "Початок (хв:сек)",
    "endTime": "Кінець (хв:сек)",
    "secondsUnit": "с",
    "fadeHelp": "Ефект може тривати весь фрагмент. Збільшення одного за потреби скорочує інший.",
    "play": "Відтворити",
    "playbackTools": "Відтворення й обрізання",
    "trimLeft": "Обрізати все ліворуч від курсора",
    "trimRight": "Обрізати все праворуч від курсора",
    "timelineHelp": "Натисніть або перетягніть на таймлайні для перемотування. Стрілки рухають курсор; пробіл вмикає або зупиняє відтворення.",
    "rotation": "Поворот (градуси)",
    "restoreAudio": "Повернути звук",
    "fadeEnvelope": "Лінія плавної зміни гучності"
  }
}
